import { Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';

const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: 'rgb(255,0,0)',
    color: 'rgba(255,255,255)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export interface IProps {
  isValid: boolean;
  message: string;
  uid: string;
}

export const ValidationControl = (props: IProps) => {
  return (
    <React.Fragment>
      <div style={{ width: '16px' }}>
        <LightTooltip title={props.message}>
          <WarningIcon
            color="inherit"
            id={props.uid}
            style={{ display: props.isValid ? 'none' : 'inline', width: '16px', height: '16px', color: '#fff' }}
          />
        </LightTooltip>
      </div>
    </React.Fragment>
  );
};

export default ValidationControl;
